module.exports = __webpack_public_path__ + "static/images/apple-gift-content-logo.fc18ce0.png";